import { FC, ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

export interface CreateObjectStepLayoutBaseProps {
  className?: string
  continueLabel?: string
  progressLabel?: string
  onBack: () => void
}

interface CreateObjectStepLayoutProps extends CreateObjectStepLayoutBaseProps {
  children: ReactNode
  continueDisabled?: boolean
  continueLoading?: boolean
  mainClassName?: string
  title: string
  onContinue: () => void
}

export const CreateObjectStepLayout: FC<CreateObjectStepLayoutProps> = ({
  children,
  className,
  continueLabel,
  continueDisabled,
  continueLoading,
  mainClassName,
  progressLabel,
  title,
  onBack,
  onContinue,
}) => {
  const { t } = useTranslation()
  const buttonLabel =
    continueLabel ?? t('kyrgyzstan_block.create_object.actions.continue')

  return (
    <div className={clsx(s.layout, className)}>
      <HeaderGoBack
        onGoBack={onBack}
        title={title}
        variant="grey"
        buttonWhite
        actionRight={
          progressLabel ? (
            <div className={clsx(s.progress, 'semi-bold-14')}>
              {progressLabel}
            </div>
          ) : undefined
        }
      />

      <main className={clsx(s.main, mainClassName)}>{children}</main>

      <ButtonContinue
        onClick={onContinue}
        type="button"
        className={clsx(s.continue, 'semi-bold-17')}
        disabled={continueDisabled}
        loading={continueLoading}
      >
        {buttonLabel}
      </ButtonContinue>
    </div>
  )
}
